import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import data from "./data.json";
import {
  checkDanhXungEnglish,
  formatDate,
  getHangChoChange,
  isEmptyObject,
  moneyFormatComma,
} from "../helpers/function_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingPage from "../components/LoadingPage";
import { datChuyen } from "../services/flightService";

export default function Service() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const isOnResponsePage = localStorage.getItem("isOnResponsePage");
    if (isOnResponsePage === "true") {
      navigate("/");
    }
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const [passengers, setPassengers] = useState(
    location.state?.passengers || []
  );
  const [flights, setFlights] = useState(
    Array.isArray(location.state?.flight)
      ? location.state.flight.filter(Boolean)
      : [location.state?.flight].filter(Boolean)
  );

  const [sweetAlert, setSweetAlert] = useState({
    isShow: false,
    baseProps: {},
  });
  const [loading, setLoading] = useState(false);
  // State mở rộng từng dòng hành khách theo chiều
  const [expanded, setExpanded] = useState({});

  const [totalFare, setTotalFare] = useState({
    tong: 0,
    tongChieuDi: 0,
    tongChieuVe: 0,
  });

  const [agreeTerms, setAgreeTerms] = useState(false);

  const onCancel = () => {
    setSweetAlert((preState) => ({
      ...preState,
      isShow: false,
    }));
  };
  const handleThanhToan = () => {
    if (agreeTerms) {
      handleConfirmThanhToan();
    }
  };

  function buildBookingDataTwo(
    flight,
    passengers,
    contact,
    tong_gia_ve,
    index_chuyen_bay
  ) {
    if (!flight) return null;
    let chuyenBay = [
      {
        index: 1,
        uuid: flight.uuid,
        index_hang_cho: flight.tuy_chon_gia_ve_mac_dinh.index,
        phi_dai_ly: flight.tuy_chon_gia_ve_mac_dinh.nguoi_lon.phi_dai_ly,
        loai_phi_dai_ly: "Cơ bản",
      },
    ];
    let hanhKhach = [];
    let danhSachHanhLy = [];
    let danhSachGhe = [];
    let danhSachDichVu = [];

    passengers.forEach((p, passengerIdx) => {
      var fullName = p.name.trim();
      var parts = fullName.split(/\s+/);
      var ho = parts[0];
      var ten = parts.slice(1).join(" ");
      hanhKhach.push({
        cha_me_id:
          p.accompanyingAdult !== "" ? Number(p.accompanyingAdult) + 1 : "",
        index: passengerIdx + 1,
        ho: ho,
        ten: ten,
        email: contact?.email,
        so_dien_thoai: contact?.so_dien_thoai,
        ngay_sinh: p.dob && p.dob !== "" ? formatDate(p.dob) : "",
        the_thanh_vien:
          flight?.hang_bay?.api == "VJ"
            ? p.the_thanh_vien_vj
            : flight?.hang_bay?.api == "QH"
            ? p.the_thanh_vien_qh
            : p.the_thanh_vien_vn,
        loai_hanh_khach: p.type == "Adult" ? 1 : p.type == "Child" ? 2 : 3,
        danh_xung: Number(p.title),
        ho_chieu:
          p.passport && p.passport !== ""
            ? {
                so_ho_chieu: p.passport,
                ngay_het_han:
                  p.ngay_het_han && p.ngay_het_han !== ""
                    ? formatDate(p.ngay_het_han)
                    : "",
                noi_phat_hanh: p.quoc_gia_cap,
                quoc_tich: p.quoc_tich,
                loai: 2,
              }
            : null,
      });
      // Hành lý
      if (p.hanh_ly && p.hanh_ly[index_chuyen_bay - 1] && p.hanh_ly[index_chuyen_bay - 1].uuid) {
        danhSachHanhLy.push({
          uuid: p.hanh_ly[index_chuyen_bay - 1].uuid,
          index_chang_bay: 1,
          index_chuyen_bay: 1,
          index_hanh_khach: passengerIdx + 1,
        });
      }
      // Ghế
      if (p.cho_ngoi && p.cho_ngoi[index_chuyen_bay - 1]) {
        Object.values(p.cho_ngoi[index_chuyen_bay - 1]).forEach(
          (gheItem, gheIndex) => {
            if (gheItem && gheItem.uuid) {
              danhSachGhe.push({
                uuid: gheItem.uuid,
                index_chang_bay: gheIndex + 1,
                index_chuyen_bay: 1,
                index_hanh_khach: passengerIdx + 1,
              });
            }
          }
        );
      }
      // Dịch vụ
      if (p.dich_vu && p.dich_vu[index_chuyen_bay - 1]) {
        Object.values(p.dich_vu[index_chuyen_bay - 1]).forEach((dvItem) => {
          if (dvItem && dvItem.uuid) {
            danhSachDichVu.push({
              uuid: dvItem.uuid,
              index_chang_bay: 1,
              index_chuyen_bay: 1,
              index_hanh_khach: passengerIdx + 1,
            });
          }
        });
      }
    });
    return {
      api: flight?.hang_bay?.api,
      chuyen_bay: chuyenBay,
      hanh_khach: hanhKhach,
      cho_ngoi: danhSachGhe,
      dich_vu: danhSachDichVu.concat(danhSachHanhLy),
      tong_gia_ve,
      trang_thai: 0,
      bao_hiem: [],
      ma_khuyen_mai: "",
      xac_nhan_ve_dup: "",
      xac_nhan_thay_doi_gia: "y",
      xac_nhan_cho_du_bi: "y",
      nhieu_chang: 0,
      thong_tin_booker: {
        ho: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ho,
        so_dien_thoai: JSON.parse(process.env.REACT_APP_BOOKER_INFO)
          .so_dien_thoai,
        email: JSON.parse(process.env.REACT_APP_BOOKER_INFO).email,
        danh_xung: JSON.parse(process.env.REACT_APP_BOOKER_INFO).danh_xung,
        ten: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
      },
    };
  }

  function buildBookingData() {
    var chuyenBay = [];
    var hanhKhach = [];
    var danhSachHanhLy = [];
    var danhSachGhe = [];
    var danhSachDichVu = [];

    passengers.forEach((p, passengerIdx) => {
      var fullName = p.name.trim();
      var parts = fullName.split(/\s+/);
      var ho = parts[0];
      var ten = parts.slice(1).join(" ");

      hanhKhach.push({
        cha_me_id:
          p.accompanyingAdult !== "" ? Number(p.accompanyingAdult) + 1 : "",
        index: passengerIdx + 1,
        ho: ho,
        ten: ten,
        email: location.state?.contact?.email,
        so_dien_thoai: location.state?.contact?.so_dien_thoai,
        ngay_sinh: p.dob && p.dob !== "" ? formatDate(p.dob) : "",
        the_thanh_vien:
          flights[0]?.hang_bay?.api == "VJ"
            ? p.the_thanh_vien_vj
            : flights[0]?.hang_bay?.api == "QH"
            ? p.the_thanh_vien_qh
            : p.the_thanh_vien_vn,
        loai_hanh_khach: p.type == "Adult" ? 1 : p.type == "Child" ? 2 : 3,
        danh_xung: Number(p.title),
        ho_chieu:
          p.passport && p.passport !== ""
            ? {
                so_ho_chieu: p.passport,
                ngay_het_han:
                  p.ngay_het_han && p.ngay_het_han !== ""
                    ? formatDate(p.ngay_het_han)
                    : "",
                noi_phat_hanh: p.quoc_gia_cap,
                quoc_tich: p.quoc_tich,
                loai: 2,
              }
            : null,
      });
    });

    flights.forEach((flight, flightIdx) => {
      chuyenBay.push({
        index: flightIdx + 1,
        uuid: flight.uuid,
        index_hang_cho: flight.tuy_chon_gia_ve_mac_dinh.index,
        phi_dai_ly: flight.tuy_chon_gia_ve_mac_dinh.nguoi_lon.phi_dai_ly,
        loai_phi_dai_ly: "Cơ bản",
      });

      passengers.forEach((p, passengerIdx) => {
        // Hành lý
        if (p.hanh_ly && p.hanh_ly[flightIdx] && p.hanh_ly[flightIdx].uuid) {
          danhSachHanhLy.push({
            uuid: p.hanh_ly[flightIdx].uuid,
            index_chang_bay: 1,
            index_chuyen_bay: flightIdx + 1,
            index_hanh_khach: passengerIdx + 1,
          });
        }
        // Ghế
        if (p.cho_ngoi && p.cho_ngoi[flightIdx]) {
          Object.values(p.cho_ngoi[flightIdx]).forEach((gheItem, gheIndex) => {
            if (gheItem && gheItem.uuid) {
              danhSachGhe.push({
                uuid: gheItem.uuid,
                index_chang_bay: gheIndex + 1,
                index_chuyen_bay: flightIdx + 1,
                index_hanh_khach: passengerIdx + 1,
              });
            }
          });
        }
        // Dịch vụ
        if (p.dich_vu && p.dich_vu[flightIdx]) {
          Object.values(p.dich_vu[flightIdx]).forEach((dvItem) => {
            if (dvItem && dvItem.uuid) {
              danhSachDichVu.push({
                uuid: dvItem.uuid,
                index_chang_bay: 1,
                index_chuyen_bay: flightIdx + 1,
                index_hanh_khach: passengerIdx + 1,
              });
            }
          });
        }
      });
    });

    var result = {
      api: flights[0]?.hang_bay?.api,
      chuyen_bay: chuyenBay,
      hanh_khach: hanhKhach,
      cho_ngoi: danhSachGhe,
      dich_vu: danhSachDichVu.concat(danhSachHanhLy),
      tong_gia_ve: totalFare.tong,
      trang_thai: 0,
      bao_hiem: [],
      ma_khuyen_mai: "",
      xac_nhan_ve_dup: "",
      xac_nhan_thay_doi_gia: "y",
      xac_nhan_cho_du_bi: "y",
      nhieu_chang: 0,
      thong_tin_booker: {
        ho: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ho,
        so_dien_thoai: JSON.parse(process.env.REACT_APP_BOOKER_INFO)
          .so_dien_thoai,
        email: JSON.parse(process.env.REACT_APP_BOOKER_INFO).email,
        danh_xung: JSON.parse(process.env.REACT_APP_BOOKER_INFO).danh_xung,
        ten: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
      },
    };
    return result;
  }

  const handleConfirmThanhToan = () => {
    if (flights.length === 0) return;

    setLoading(true);
    const allApi = flights.map((f) => f?.hang_bay?.api);
    const isAllSame = allApi.every((api) => api === allApi[0]);
    if (isAllSame) {
      const result = buildBookingData();

      const callApi = (payload) => datChuyen(payload);

      const handleSuccess = (data) => {
        // setSweetAlert({
        //   isShow: true,
        //   baseProps: {
        //     title: "Thông báo",
        //     type: "success",
        //     confirmBtnBsStyle: "success",
        //     showConfirm: false,
        //     showCancel: false,
        //     showCloseButton: true,
        //     onCancel: onCancel,
        //     ContentRender: <div>{data.message}</div>,
        //     onConfirm: onCancel,
        //   },
        // });
        // setTimeout(() => handleNextPage([data]), 3000);
        handleNextPage([data]);
      };

      const handleError = (data) => {
        setSweetAlert({
          isShow: true,
          baseProps: {
            title: "Thông báo",
            type: "warning",
            confirmBtnBsStyle: "danger",
            showConfirm: false,
            showCancel: false,
            showCloseButton: true,
            onCancel: onCancel,
            onConfirm: onCancel,
            ContentRender: <div>{data.message}</div>,
          },
        });
      };

      // Hàm xử lý kết quả (đệ quy khi gặp 307/308)
      const handleResponse = async (payload) => {
        try {
          const data = await callApi(payload);
          setLoading(false);

          if (data.code === 200) {
            handleSuccess(data);
          } else if (data.code === 307) {
            setSweetAlert({
              isShow: true,
              baseProps: {
                title: "Thông báo",
                type: "warning",
                confirmBtnBsStyle: "success",
                cancelBtnBsStyle: "danger",
                confirmBtnText: "Đồng ý",
                cancelBtnText: "Đóng",
                showConfirm: true,
                showCancel: true,
                onConfirm: () => {
                  setLoading(true);
                  handleResponse({ ...payload, xac_nhan_thay_doi_gia: "y" });
                  onCancel();
                },
                onCancel: onCancel,
                ContentRender: <div>{data.message}</div>,
              },
            });
          } else if (data.code === 308) {
            setSweetAlert({
              isShow: true,
              baseProps: {
                title: "Thông báo",
                type: "warning",
                confirmBtnBsStyle: "success",
                confirmBtnText: "Đồng ý",
                cancelBtnBsStyle: "danger",
                cancelBtnText: "Đóng",
                showConfirm: true,
                showCancel: true,
                onConfirm: () => {
                  setLoading(true);
                  handleResponse({
                    ...payload,
                    xac_nhan_thay_doi_gia: "y",
                    xac_nhan_cho_du_bi: "y",
                  });
                  onCancel();
                },
                onCancel: onCancel,
                ContentRender: <div>{data.message}</div>,
              },
            });
          } else {
            handleError(data);
          }
        } catch (error) {
          setLoading(false);
        }
      };

      // Bắt đầu gọi API lần đầu
      handleResponse(result);
    } else {
      // Tạo result cho từng chiều
      var resultChieuDi = buildBookingDataTwo(
        flights[0],
        passengers,
        location.state?.contact,
        totalFare.tongChieuDi,
        1
      );

      var resultChieuVe = buildBookingDataTwo(
        flights[1],
        passengers,
        location.state?.contact,
        totalFare.tongChieuVe,
        2
      );

      // Hàm xử lý đệ quy cho API booking
      const processBookingRecursively = async (
        dataDi,
        dataVe,
        isUserConfirmed = false
      ) => {
        // Kiểm tra điều kiện dừng đệ quy
        const isCompleted = (code) => code === 200 || code === 400;
        const needsConfirmation = (code) => code === 307 || code === 308;

        // Nếu cả 2 chiều đã hoàn thành
        if (isCompleted(dataDi?.code) && isCompleted(dataVe?.code)) {
          setLoading(false);
          const isSuccess = dataDi?.code === 200 && dataVe?.code === 200;

          // Nếu có ít nhất 1 chiều thành công thì chuyển trang
          if (dataDi?.code === 200 || dataVe?.code === 200) {
            // setTimeout(() => {
            //   handleNextPage([dataDi, dataVe]);
            // }, 3000);
            handleNextPage([dataDi, dataVe]);
          } else {
            setSweetAlert({
              isShow: true,
              baseProps: {
                title: "Thông báo",
                type: isSuccess ? "success" : "warning",
                confirmBtnBsStyle: "success",
                showConfirm: false,
                showCancel: false,
                showCloseButton: true,
                onCancel: onCancel,
                ContentRender: (
                  <div>
                    <div>
                      <span style={{ color: "#1976d2" }}>
                        Chiều đi ({flights[0]?.hang_bay?.ma})
                      </span>
                      : {dataDi?.message}
                    </div>
                    <div className="mt-2">
                      <span style={{ color: "#1976d2" }}>
                        Chiều về ({flights[1]?.hang_bay?.ma})
                      </span>
                      : {dataVe?.message}
                    </div>
                  </div>
                ),
                onConfirm: onCancel,
              },
            });
          }
          return;
        }

        // Nếu có ít nhất 1 chiều cần xác nhận (307 hoặc 308) và chưa được user xác nhận
        if (
          !isUserConfirmed &&
          (needsConfirmation(dataDi?.code) || needsConfirmation(dataVe?.code))
        ) {
          setLoading(false);
          setSweetAlert({
            isShow: true,
            baseProps: {
              title: "Thông báo",
              type: "warning",
              confirmBtnBsStyle: "success",
              showConfirm: true,
              cancelBtnBsStyle: "danger",
              confirmBtnText: "Chấp nhận",
              cancelBtnText: "Từ chối",
              showCloseButton: true,
              showCancel: true,
              onCancel: () => {
                if (dataDi?.code == 200 || dataVe?.code == 200) {
                  handleNextPage([dataDi, dataVe]);
                } else {
                  onCancel();
                }
              },
              onConfirm: async () => {
                setSweetAlert((preState) => ({
                  ...preState,
                  isShow: false,
                }));
                setLoading(true);

                // Gọi đệ quy với xác nhận từ user
                await processBookingRecursively(dataDi, dataVe, true);
              },
              ContentRender: (
                <div>
                  <div>
                    <span style={{ color: "#1976d2" }}>
                      Chiều đi ({flights[0]?.hang_bay?.ma})
                    </span>
                    : {dataDi?.message}
                  </div>
                  <div className="mt-2">
                    <span style={{ color: "#1976d2" }}>
                      Chiều về ({flights[1]?.hang_bay?.ma})
                    </span>
                    : {dataVe?.message}
                  </div>
                </div>
              ),
            },
          });
          return;
        }

        // Chuẩn bị request cho các chiều cần xử lý tiếp
        let reqDi, reqVe;
        let needsApiCallDi = !isCompleted(dataDi?.code);
        let needsApiCallVe = !isCompleted(dataVe?.code);

        if (needsApiCallDi) {
          // Chiều đi cần xử lý tiếp
          reqDi = datChuyen({
            ...resultChieuDi,
            xac_nhan_thay_doi_gia: needsConfirmation(dataDi?.code) ? "y" : "",
            xac_nhan_cho_du_bi: dataDi?.code === 308 ? "y" : "",
          });
        }

        if (needsApiCallVe) {
          // Chiều về cần xử lý tiếp
          reqVe = datChuyen({
            ...resultChieuVe,
            xac_nhan_thay_doi_gia: needsConfirmation(dataVe?.code) ? "y" : "",
            xac_nhan_cho_du_bi: dataVe?.code === 308 ? "y" : "",
          });
        }

        // Nếu cả hai chiều đều đã hoàn thành, không cần gọi API
        if (!needsApiCallDi && !needsApiCallVe) {
          processBookingRecursively(dataDi, dataVe, false);
          return;
        }

        // Nếu chỉ có 1 chiều cần gọi API
        if (needsApiCallDi && !needsApiCallVe) {
          reqDi
            .then((data) => {
              processBookingRecursively(data, dataVe, false);
            })
            .catch((error) => {
              setLoading(false);
            });
          return;
        }

        if (!needsApiCallDi && needsApiCallVe) {
          reqVe
            .then((data) => {
              processBookingRecursively(dataDi, data, false);
            })
            .catch((error) => {
              setLoading(false);
            });
          return;
        }

        // Nếu cả hai chiều đều cần gọi API
        Promise.allSettled([reqDi, reqVe]).then((results) => {
          var [resDi, resVe] = results;

          let newDataDi = dataDi,
            newDataVe = dataVe;

          if (needsApiCallDi && resDi.status === "fulfilled") {
            newDataDi = resDi.value;
          }

          if (needsApiCallVe && resVe.status === "fulfilled") {
            newDataVe = resVe.value;
          }

          // Gọi đệ quy với kết quả mới
          processBookingRecursively(newDataDi, newDataVe, false);
        });
      };

      // Bắt đầu quá trình booking
      var reqDi = datChuyen(resultChieuDi);
      var reqVe = datChuyen(resultChieuVe);
      Promise.allSettled([reqDi, reqVe]).then((results) => {
        var [resDi, resVe] = results;

        let dataDi = null,
          dataVe = null;
        if (resDi.status === "fulfilled") {
          dataDi = resDi.value;
        }
        if (resVe.status === "fulfilled") {
          dataVe = resVe.value;
        }

        // Bắt đầu xử lý đệ quy
        processBookingRecursively(dataDi, dataVe, false);
      });
    }
  };

  const handleNextPage = (data) => {
    navigate("/thong-tin-ve", {
      state: {
        passengers,
        flight: location.state?.flight,
        contact: location.state?.contact,
        data: data,
      },
    });
  };

  useEffect(() => {
    // Tính tổng tiền từng chiều và tổng cộng, lưu vào state
    let tongChieuDi = 0;
    let tongChieuVe = 0;
    let tong = 0;
    [0, 1].forEach((chieuIdx) => {
      if (!flights[chieuIdx]) return;
      passengers.forEach((p) => {
        const fare = flights[chieuIdx]?.tuy_chon_gia_ve_mac_dinh;
        if (!fare) return;
        if (p.type === "Adult") tong += fare.nguoi_lon?.gia_dai_ly || 0;
        if (p.type === "Child") tong += fare.tre_em?.gia_dai_ly || 0;
        if (p.type === "Infant") tong += fare.em_be?.gia_net || 0;
        // Hành lý
        if (p.hanh_ly && p.hanh_ly[chieuIdx]) {
          tong += p.hanh_ly[chieuIdx].gia_net || 0;
        }
        // Ghế
        if (p.cho_ngoi && p.cho_ngoi[chieuIdx])
          Object.values(p.cho_ngoi[chieuIdx]).forEach(
            (ghe) => (tong += ghe.gia_net || 0)
          );
        // Dịch vụ khác
        if (p.dich_vu && p.dich_vu[chieuIdx])
          Object.values(p.dich_vu[chieuIdx]).forEach(
            (dv) => (tong += dv.gia_net || 0)
          );
        // Lưu riêng từng chiều
        if (chieuIdx === 0) {
          if (p.type === "Adult")
            tongChieuDi += fare.nguoi_lon?.gia_dai_ly || 0;
          if (p.type === "Child") tongChieuDi += fare.tre_em?.gia_dai_ly || 0;
          if (p.type === "Infant") tongChieuDi += fare.em_be?.gia_net || 0;
          if (p.hanh_ly && p.hanh_ly[0]) {
             tongChieuDi += p.hanh_ly[0].gia_net || 0;
          }
          if (p.cho_ngoi && p.cho_ngoi[0])
            Object.values(p.cho_ngoi[0]).forEach(
              (ghe) => (tongChieuDi += ghe.gia_net || 0)
            );
          if (p.dich_vu && p.dich_vu[0])
            Object.values(p.dich_vu[0]).forEach(
              (dv) => (tongChieuDi += dv.gia_net || 0)
            );
        }
        if (chieuIdx === 1) {
          if (p.type === "Adult")
            tongChieuVe += fare.nguoi_lon?.gia_dai_ly || 0;
          if (p.type === "Child") tongChieuVe += fare.tre_em?.gia_dai_ly || 0;
          if (p.type === "Infant") tongChieuVe += fare.em_be?.gia_net || 0;
          if (p.hanh_ly && p.hanh_ly[1]) {
             tongChieuVe += p.hanh_ly[1].gia_net || 0;
          }
          if (p.cho_ngoi && p.cho_ngoi[1])
            Object.values(p.cho_ngoi[1]).forEach(
              (ghe) => (tongChieuVe += ghe.gia_net || 0)
            );
          if (p.dich_vu && p.dich_vu[1])
            Object.values(p.dich_vu[1]).forEach(
              (dv) => (tongChieuVe += dv.gia_net || 0)
            );
        }
      });
    });
    setTotalFare({
      tong,
      tongChieuDi,
      tongChieuVe,
    });
  }, [flights, passengers]);

  return (
    <section id="tour_booking_submission" className="section_padding">
      {loading && <LoadingPage />}
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="tou_booking_form_Wrapper">
              <div className="booking_tour_form">
                <h3 className="heading_theme">Thông tin thanh toán</h3>
                <div className="tour_booking_form_box">
                  <div className="row">
                    {/* Card: Thông tin chuyến bay */}
                    <div className="col-lg-6 col-12">
                      <h5 className="mb-1" style={{ fontSize: 20 }}>
                        Thông tin chuyến bay
                      </h5>
                      <div className="row">
                        {flights.map((flight, idx) => (
                          <div key={idx} className="col-lg-12 col-12 mt-2">
                            <div
                              className="card"
                              style={{
                                border: "1px solid #e0e6ed",
                                borderRadius: 12,
                                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                background:
                                  "linear-gradient(135deg, #f8fbff 0%, #e8f4fd 100%)",
                                overflow: "hidden",
                              }}
                            >
                              <div className="card-body p-4">
                                <div className="row align-items-center">
                                  <div className="col-lg-2 col-md-3 text-center mb-3 mb-md-0">
                                    {flight?.hang_bay?.logo && (
                                      <img
                                        src={flight.hang_bay.logo}
                                        alt="logo"
                                        style={{
                                          width: 80,
                                          height: "auto",
                                          // borderRadius: 8,
                                          // boxShadow:
                                          //   "0 2px 8px rgba(0,0,0,0.1)",
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div className="col-lg-10 col-md-9">
                                    <div className="row">
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Số hiệu chuyến bay
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 16,
                                            fontWeight: 600,
                                            color: "#1976d2",
                                          }}
                                        >
                                          {flight?.so_hieu || ""}
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Ngày bay
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 15,
                                            fontWeight: 600,
                                            color: "#333",
                                          }}
                                        >
                                          {flight?.ngay_di.replaceAll("-", "/")}
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-3 text-center">
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: "#666",
                                            fontWeight: 500,
                                          }}
                                        >
                                          Hạng vé
                                        </div>
                                        <div
                                          style={{
                                            fontSize: 15,
                                            fontWeight: 600,
                                            color: "#333",
                                          }}
                                        >
                                          {getHangChoChange(
                                            flight.tuy_chon_gia_ve_mac_dinh.ten
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-2 text-center">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div>
                                            <div
                                              style={{
                                                fontSize: 18,
                                                fontWeight: 700,
                                                color: "#1976d2",
                                              }}
                                            >
                                              {flight?.gio_di}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: 13,
                                                color: "#666",
                                              }}
                                            >
                                              {flight?.diem_di?.tinh || ""} (
                                              {flight?.diem_di?.ma || ""})
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 text-center mb-2 d-flex align-items-center justify-content-center">
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#666",
                                            }}
                                          >
                                            {flight?.thoi_gian_bay || ""}
                                          </div>
                                          <div
                                            style={{
                                              borderTop: "2px solid #1976d2",
                                              margin: "4px 0",
                                              position: "relative",
                                            }}
                                          >
                                            <i
                                              className="fas fa-plane"
                                              style={{
                                                position: "absolute",
                                                top: "-9px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                color: "#1976d2",
                                                background: "#eff6fe",
                                                padding: "0 4px",
                                              }}
                                            ></i>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-6 mb-2 text-center">
                                        <div className="d-flex align-items-center justify-content-center">
                                          <div>
                                            <div
                                              style={{
                                                fontSize: 18,
                                                fontWeight: 700,
                                                color: "#1976d2",
                                              }}
                                            >
                                              {flight?.gio_den}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: 13,
                                                color: "#666",
                                              }}
                                            >
                                              {flight?.diem_den?.tinh || ""} (
                                              {flight?.diem_den?.ma || ""})
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* Card: Thông tin hành khách */}
                    <div className="col-lg-6 col-12">
                      <h5 className="mb-2" style={{ fontSize: 20 }}>
                        Thông tin hành khách
                      </h5>
                      <div className="row">
                        {/* Danh sách hành khách và chi tiết giá */}
                        <div>
                          {(() => {
                            // Nếu có flight.hang_bay.api === "uAPI" thì chỉ lấy chiều đi (chieuIdx === 0)
                            let filteredFlights = flights;
                            var checkUAPI = false
                            if (flights.some((f) => f?.hang_bay?.api === "uAPI")) {
                              checkUAPI = true
                              filteredFlights = flights.filter(
                                (f, idx) => idx === 0
                              );
                            }
                            return filteredFlights.map((flight, chieuIdx) => (
                              <div key={chieuIdx} style={{ marginBottom: 12 }}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 18,
                                    marginBottom: 4,
                                    color: "#1976d2",
                                  }}
                                ></div>
                                <div>
                                  {passengers.map((p, idx) => {
                                    // Tính tổng tiền của hành khách này cho chiều này
                                    let fare = flight?.tuy_chon_gia_ve_mac_dinh;
                                    let price = 0;
                                    let fareType = null;
                                    if (fare) {
                                      if (p.type === "Adult") {
                                        price +=
                                          fare.nguoi_lon?.gia_dai_ly || 0;
                                        fareType = fare.nguoi_lon;

                                        if(checkUAPI){
                                          price += flights[1] ? flights[1].tuy_chon_gia_ve_mac_dinh.nguoi_lon.phi_dai_ly : 0;
                                        }
                                      }
                                      if (p.type === "Child") {
                                        price += fare.tre_em?.gia_dai_ly || 0;
                                        fareType = fare.tre_em;
                                        if(checkUAPI){
                                          price += flights[1] ? flights[1].tuy_chon_gia_ve_mac_dinh.tre_em.phi_dai_ly : 0;
                                        }
                                      }
                                      if (p.type === "Infant") {
                                        price += fare.em_be?.gia_net || 0;
                                        fareType = fare.em_be;
                                      }
                                    }
                                    let hanhLyArr = {};
                                    if (
                                      p.hanh_ly &&
                                      p.hanh_ly[chieuIdx] &&
                                      !isEmptyObject(p.hanh_ly[chieuIdx])
                                    ) {
                                      hanhLyArr = p.hanh_ly[chieuIdx];
                                      price += hanhLyArr.gia_net || 0;
                                    }
                                    let gheArr = [];
                                    if (p.cho_ngoi && p.cho_ngoi[chieuIdx]) {
                                      gheArr = Object.values(
                                        p.cho_ngoi[chieuIdx]
                                      ).filter((ghe) => ghe && ghe.ma_ghe);
                                      gheArr.forEach(
                                        (ghe) => (price += ghe.gia_net || 0)
                                      );
                                    }
                                    let dvArr = [];
                                    if (p.dich_vu && p.dich_vu[chieuIdx]) {
                                      dvArr = Object.values(
                                        p.dich_vu[chieuIdx]
                                      ).filter((dv) => dv && dv.ten);
                                      dvArr.forEach(
                                        (dv) => (price += dv.gia_net || 0)
                                      );
                                    }
                                    let fareValue = 0;
                                    if (fareType)
                                      fareValue = fareType.gia_fare || 0;
                                    const isExpanded =
                                      expanded[`${chieuIdx}-${idx}`] || false;

                                    return (
                                      <div
                                        key={idx}
                                        style={{
                                          border: "1px solid #e0e0e0",
                                          borderRadius: 8,
                                          marginBottom: 8,
                                          background: isExpanded
                                            ? "linear-gradient(90deg,#e3f0ff 0%,#f8fbff 100%)"
                                            : "linear-gradient(90deg,#f8fbff 0%,#e3f0ff 100%)",
                                          transition: "background 0.2s",
                                          cursor: "pointer",
                                          padding: isExpanded
                                            ? "14px 0px 0px 0px"
                                            : "14px 0px",
                                          fontWeight: 500,
                                          boxShadow: isExpanded
                                            ? "0 2px 8px rgba(25,118,210,0.08)"
                                            : "none",
                                          fontSize: 14,
                                        }}
                                        onClick={() =>
                                          setExpanded((prev) => ({
                                            ...prev,
                                            [`${chieuIdx}-${idx}`]:
                                              !prev[`${chieuIdx}-${idx}`],
                                          }))
                                        }
                                      >
                                        <span style={{ marginLeft: 8 }}>
                                          {p.name}
                                        </span>
                                        <span
                                          style={{
                                            float: "right",
                                            color: "#1976d2",
                                            marginRight: 8,
                                            fontWeight: 700,
                                            fontSize: 18,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                          }}
                                        >
                                          {moneyFormatComma(price)}
                                          <span
                                            style={{
                                              display: "inline-block",
                                              transition: "transform 0.2s",
                                              transform: isExpanded
                                                ? "rotate(90deg)"
                                                : "rotate(0deg)",
                                            }}
                                          >
                                            ▶
                                          </span>
                                        </span>
                                        {isExpanded && (
                                          <div style={{ marginTop: 8 }}>
                                            <div className="table-responsive">
                                              <table
                                                className="table table-sm table-bordered align-middle"
                                                style={{
                                                  fontSize: 13,
                                                  marginBottom: 0,
                                                  minWidth: 600,
                                                }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th
                                                      style={{
                                                        minWidth: 180,
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Tên
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: 140,
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      Giá tiền
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {/* Tách chi_tiet_thue thành 2 hàng: Vé máy bay (Fare) và Thuế phí (còn lại) */}
                                                  <tr>
                                                    <td
                                                      style={{
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      Vé máy bay
                                                    </td>
                                                    <td
                                                      style={{
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      {moneyFormatComma(
                                                        fareType.gia_fare
                                                      )}
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td
                                                      style={{
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      Thuế phí
                                                    </td>
                                                    <td
                                                      style={{
                                                        height: 35,
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      {moneyFormatComma(
                                                        fareType.thue + (p.type === "Infant" ? 0 : (fareType.phi_dai_ly + (checkUAPI ? (flights[1] ? flights[1].tuy_chon_gia_ve_mac_dinh[p.type == "Adult" ? "nguoi_lon" : "tre_em"].phi_dai_ly : 0) : 0)))
                                                      )}
                                                    </td>
                                                  </tr>
                                                  {/* Hành lý */}
                                                  {hanhLyArr &&
                                                  !isEmptyObject(hanhLyArr) ? (
                                                    <tr key={"baggage"}>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        {hanhLyArr.ten_hien_thi ||
                                                          hanhLyArr.ten}{" "}
                                                        ({hanhLyArr.so_kg}kg)
                                                      </td>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        {moneyFormatComma(
                                                          hanhLyArr.gia_net || 0
                                                        )}
                                                      </td>
                                                    </tr>
                                                  ) : null}

                                                  {/* Ghế */}
                                                  {gheArr.map((ghe, i) => (
                                                    <tr key={"seat-" + i}>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        Ghế: {ghe.ma_ghe}
                                                      </td>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        {moneyFormatComma(
                                                          ghe.gia_net || 0
                                                        )}
                                                      </td>
                                                    </tr>
                                                  ))}
                                                  {/* Dịch vụ */}
                                                  {dvArr.map((dv, i) => (
                                                    <tr key={"service-" + i}>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        {dv.ten_hien_thi ||
                                                          dv.ten}
                                                      </td>
                                                      <td
                                                        style={{
                                                          height: 35,
                                                          verticalAlign:
                                                            "middle",
                                                        }}
                                                      >
                                                        {moneyFormatComma(
                                                          dv.gia_net || 0
                                                        )}
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ));
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tổng tiền phải thanh toán */}
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: 16,
                      marginTop: 12,
                      background: "#f5f7fa",
                      borderRadius: 8,
                      padding: "14px 20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
                    }}
                  >
                    Tổng tiền phải thanh toán
                    <span
                      style={{
                        color: "#1976d2",
                        marginLeft: 8,
                        fontSize: 20,
                      }}
                    >
                      {moneyFormatComma(totalFare.tong, false)}
                    </span>
                    {/* <div style={{ fontWeight: 400, fontSize: 15, marginTop: 6 }}>
                          Tổng tiền chiều đi: <span style={{ color: "#1976d2" }}>{moneyFormatComma(totalFare.tongChieuDi, false)}</span>
                          {flights.length > 1 && (
                            <>
                              <span style={{ margin: "0 12px" }}>|</span>
                              Tổng tiền chiều về: <span style={{ color: "#1976d2" }}>{moneyFormatComma(totalFare.tongChieuVe, false)}</span>
                            </>
                          )}
                        </div> */}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-12 mt-3"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="agreeTerms"
                        checked={agreeTerms}
                        onChange={(e) => setAgreeTerms(e.target.checked)}
                        style={{
                          transform: "scale(1.2)",
                          marginRight: "8px",
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="agreeTerms"
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#333",
                          cursor: "pointer",
                        }}
                      >
                        Tôi đồng ý với các điều khoản và điều kiện của dịch vụ
                      </label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-secondary"
                        style={{ minWidth: 150 }}
                        onClick={() => {
                          var airCheck = location.state.flight.filter(
                            (item) =>
                              item?.hang_bay?.api === "uAPI" ||
                              item?.hang_bay?.api === "QH"
                          );

                          if (airCheck.length > 0) {
                            navigate("/thong-tin-hanh-khach", {
                              state: {
                                passengers: location.state?.passengers,
                                flight: location.state?.flight,
                                contact: location.state?.contact,
                                isReturn: true,
                              },
                            });
                            return;
                          }
                          navigate("/thong-tin-dich-vu", {
                            state: {
                              passengers: location.state?.passengers,
                              flight: location.state?.flight,
                              contact: location.state?.contact,
                              fromPayInfo: true,
                              dsDichVu: location.state?.dsDichVu || {},
                            },
                          });
                        }}
                      >
                        Quay lại
                      </button>
                      <button
                        className="btn btn-primary ms-2"
                        style={{
                          minWidth: 150,
                          fontWeight: 600,
                          fontSize: 14,
                          borderRadius: 8,
                          boxShadow: "0 2px 8px rgba(25,118,210,0.15)",
                          padding: "12px 24px",
                          opacity: agreeTerms ? 1 : 0.6,
                          cursor: agreeTerms ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          handleThanhToan();
                        }}
                      >
                        Đặt vé
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {sweetAlert.isShow === true && (
        <SweetAlert {...sweetAlert.baseProps}>
          {sweetAlert.baseProps.ContentRender}
        </SweetAlert>
      )}
    </section>
  );
}
